import { FormInput } from 'components/molecules';
import { t } from 'i18next';
import { object, string } from 'yup';
import PopupForm, { IPopupFormProps } from '../form/PopupForm';

export interface ICodes {
  codes: string[];
  text: string;
}

const validator = object().shape({
  text: string().required(() => t('formik-error.required')),
});

interface ICodesParserPopupProps
  extends Omit<IPopupFormProps<ICodes>, 'children' | 'initialValues'> {}

const CodesParserPopup = ({ ...props }: ICodesParserPopupProps) => {
  return (
    <PopupForm
      {...props}
      initialValues={{ text: '', codes: [] }}
      validationSchema={validator}>
      {({ setFieldValue, values }) => (
        <>
          {/* <div className='flex flex-col w-full px-8 text-base opacity-65 max-w-72'>
            Tutaj z łatwością możesz wkleić swoje kody z dowolnym separatorem, a
            my je wykryjemy i dodamy do systemu.
          </div> */}
          <FormInput.Field
            name='text'
            style={{ minHeight: 250 }}
            // label={t('input.label.codes')}
            onChange={e => {
              const codes: string[] = [];
              let code = '';
              for (const char of e.currentTarget.value) {
                const match = !!char.match(/[a-zA-Z0-9]/);

                if (match) {
                  code += char;
                }

                if (!match && code.length) {
                  codes.push(code);
                  code = '';
                }
              }

              if (!!code.length) {
                codes.push(code);
              }
              console.log(codes);
              setFieldValue('codes', codes);
            }}
            placeholder={t('input.placeholder.codes')}
          />
          <div className='flex flex-col w-full max-w-72 px-8 text-base opacity-65'>
            {/* <p>Znaki: {values.text.length}</p> */}
            <p>
              {t('popup.codes-detected')}: {values.codes.length}
            </p>
          </div>
        </>
      )}
    </PopupForm>
  );
};

export default CodesParserPopup;
